/**
 * 品牌配置文件
 * 通过环境变量 VUE_APP_BRAND 在构建时确定品牌
 * 
 * 使用方式：
 * - npm run build          -> 星博娱乐 (默认)
 * - npm run build:k8vips   -> K8娱乐
 */

// 品牌配置定义
const brandConfigs = {
  // 星博娱乐 (默认)
  xingbo: {
    name: 'xingbo',
    title: '星博娱乐',
    description: '星博娱乐游戏平台',
    fullDescription: '星博娱乐游戏平台 - 安全、公平、刺激的在线娱乐体验',
    themeColor: '#facc15',
    liveChatLicense: 19387318,
    apiHost: 'https://api.xbyl28.com',
    wsHost: 'wss://api.xbyl28.com',
    // 资源文件
    favicon: 'favicon.ico',
    icon192: 'icon_192.png',
    icon512: 'icon_512.png',
    // 背景图
    bgImage: 'bg.jpg',
    // 首页 banner 图片
    bannerImages: ['card_0.png', 'card_1.png'],
  },
  
  // K8娱乐
  k8vips: {
    name: 'k8vips',
    title: 'K8娱乐',
    description: 'K8娱乐游戏平台',
    fullDescription: 'K8娱乐游戏平台 - 安全、公平、刺激的在线娱乐体验',
    themeColor: '#facc15',
    liveChatLicense: 19433131,
    apiHost: 'https://api.k8vips.com',
    wsHost: 'wss://api.k8vips.com',
    // 资源文件
    favicon: 'k8vips.jpeg',
    icon192: 'k8vips-512.jpg',
    icon512: 'k8vips-512.jpg',
    // 背景图
    bgImage: 'bg_k8.jpeg',
    // 首页 banner 图片
    bannerImages: ['card_1_k8.jpeg'],
  }
}

// 获取当前品牌配置
// 优先使用构建时的环境变量，如果没有则默认使用 xingbo
const currentBrand = process.env.VUE_APP_BRAND || 'xingbo'

// 导出当前品牌配置
export const brand = brandConfigs[currentBrand] || brandConfigs.xingbo

// 导出所有品牌配置（用于调试或其他用途）
export const allBrands = brandConfigs

// 导出当前品牌名称
export const brandName = currentBrand

// 获取背景图（动态导入）
export function getBgImage() {
  if (brand.name === 'k8vips') {
    return require('@/assets/bg_k8.jpeg')
  }
  return require('@/assets/bg.jpg')
}

// 获取首页 banner 图片列表
export function getBannerImages() {
  return brand.bannerImages.map(img => require(`@/assets/${img}`))
}

// 是否为 K8 品牌
export const isK8Brand = currentBrand === 'k8vips'

export default brand

